/**
 * *************************
 * System Admin Components *
 * *************************
 */
 const SystemAdminMain = () => import('@/components/SystemAdmin/SystemAdminMain');

// Mail Sync Routes
const MailSync = () => import('@/components/SystemAdmin/MailSync');
const MailSyncReport = () => import('@/components/SystemAdmin/MailSyncReport');

export default {
    parent: 'Platform Admin',
    path: '/platfrom-admin',
    name: 'SystemAdmin',
    redirect: '/platfrom-admin/mail-sync/p1',

    meta: {
        permission: [
            {
                action: 'manage',
                entity: 'system'
            }
        ]
    },
    component: SystemAdminMain,
    children: [
        //     // {
        //     //   title: 'Queues',
        //     //   link: '/system-admin/queues'
        //     // },
        //     // {
        //     //   title: 'Error Emails',
        //     //   link: '/system-admin/error-emails'
        //     // },
        //     // {
        //     //   title: 'Email Flow',
        //     //   link: '/system-admin/email-flow'
        //     // },
        //     // {
        //     //   title: 'Workflows',
        //     //   link: '/system-admin/workflow'
        //     // },
        //     // {
        //     //   title: 'Metrics',
        //     //   link: '/system-admin/metrics'
        //     // },
        //     // {
        //     //   title: 'Settings',
        //     //   link: '/system-admin/settings'
        //     // },

        {
            path: 'mail-sync/p:pageNumber?',
            component: MailSync,
            props: { pageType: 'SYSTEM_ADMIN' },
            title: 'Mail Synchronisation',
            link: '/platfrom-admin/mail-sync/p1',
            permission: [
                {
                    action: 'manage',
                    entity: 'system'
                }
            ]
        },
        {
            path: 'mail-sync/:mailSyncId',
            component: MailSyncReport,
            props: { pageType: 'SYSTEM_ADMIN' }
        }
    ]
};